import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";

const SectionPage = ({ eyebrow, title, subtitle, groups, badge }) => (
  <main data-testid={`section-page-${eyebrow.toLowerCase().replace(/\s+/g, "-")}`}>
    <section className="py-24 bg-[#00142D] relative overflow-hidden">
      <div className="absolute -top-32 right-0 w-[420px] h-[420px] rounded-full bg-[#1679B5]/25 blur-[110px]" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <p className="text-[11px] font-extrabold tracking-[0.22em] uppercase text-[#32B5E8] mb-4">{eyebrow}</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight max-w-3xl">{title}</h1>
        <p className="mt-5 text-base md:text-lg text-slate-300 max-w-2xl leading-relaxed">{subtitle}</p>
        {badge && (
          <p data-testid="iso-badge" className="mt-7 inline-flex items-center gap-2 text-xs font-extrabold tracking-[0.14em] uppercase text-[#8BCB32] border border-[#8BCB32]/30 bg-[#8BCB32]/10 rounded-full px-4 py-2">
            <ShieldCheck size={14} /> {badge}
          </p>
        )}
      </div>
    </section>
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {groups.map((g) => (
          <div key={g.title} className="rounded-2xl border border-slate-200 bg-[#F5F8FA] p-7">
            <p className="text-sm font-extrabold text-[#081D35] mb-4 pb-3 border-b border-slate-200">{g.title}</p>
            <ul className="space-y-2.5">
              {g.items.map((item) => (
                <li key={item} id={item.toLowerCase().replace(/[^a-z0-9]+/g, "-")} className="text-sm text-[#64748B] flex items-center gap-2 scroll-mt-24">
                  <span className="w-1.5 h-1.5 rounded-full bg-gradient-to-r from-[#1679B5] to-[#32B5E8]" /> {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 mt-14 text-center">
        <Link data-testid="section-plan-event-cta" to="/plan-your-event" className="ev-btn-primary inline-flex items-center gap-2 text-white text-sm font-bold px-8 py-4 rounded-full">
          Plan Your Event <ArrowRight size={16} />
        </Link>
      </div>
    </section>
  </main>
);

export default SectionPage;
